import { UpdateUserVerification as UpdateUserVerificationService } from '@jaymathew/ui-shared/apis/User'
import { useMutation } from '@tanstack/react-query'
import { HttpsCallableResult } from 'firebase/functions'

type  UpdateUserVerificationInput = string

interface MutationCallbacks {
	onSuccess?: (data: HttpsCallableResult<unknown>) => void
	onError?: (err: Error) => void
}

export const useUpdateUserVerificationMutation = (callbacks: MutationCallbacks = {}) => {

	return useMutation<HttpsCallableResult<unknown>, Error, UpdateUserVerificationInput>({
		mutationFn: UpdateUserVerificationService,
		onSuccess: (data) => {
			callbacks.onSuccess?.(data)
		},
		onError: (error) => {
			callbacks.onError?.(error)
		},
	})
}
